const primitiveColors = {
  color: {
    red: {
      100: {
        light: '#FFEBEB',
        dark: '#55160C',
      },
      500: {
        light: '#D0021B',
        dark: '#FFA6AF',
      },
    },
    green: {
      100: {
        light: '#F2FFF8',
        dark: '#053321',
      },
      500: {
        light: '#127842',
        dark: '#90F09D',
      },
    },
    yellow: {
      500: {
        light: '#FFC72C',
        dark: '#FFC72C',
      },
    },
    neutral: {
      0: {
        light: '#FFFFFF',
        dark: '#161B26',
      },
      100: {
        light: '#F5F5F5',
        dark: '#0C111D',
      },
      200: {
        light: '#E5E5E5',
        dark: '#333741',
      },
      300: {
        light: '#6E6E6E',
        dark: '#85888E',
      },
      400: {
        light: '#222222',
        dark: '#F2F2F2',
      },
      500: {
        light: '#000000',
        dark: '#FFFFFF',
      },
    },
    white: {
      alpha: {
        30: {
          light: '#FFFFFF4D',
          dark: '#FFFFFF4D',
        },
        20: {
          light: '#FFFFFF33',
          dark: '#FFFFFF33',
        },
      },
    },
    black: {
      alpha: {
        30: {
          light: '#0000004D',
          dark: '#0000004D',
        },
        20: {
          light: '#00000033',
          dark: '#00000033',
        },
      },
    },
  },

}

const generatePrimitiveColors = (systemTheme) => {
  const primitives = primitiveColors.color
  return {
    red: {
      100: primitives.red[100][systemTheme],
      500: primitives.red[500][systemTheme],
    },
    green: {
      100: primitives.green[100][systemTheme],
      500: primitives.green[500][systemTheme],
    },
    yellow: {
      500: primitives.yellow[500][systemTheme],
    },
    neutral: {
      0: primitives.neutral[0][systemTheme],
      100: primitives.neutral[100][systemTheme],
      200: primitives.neutral[200][systemTheme],
      300: primitives.neutral[300][systemTheme],
      400: primitives.neutral[400][systemTheme],
      500: primitives.neutral[500][systemTheme],
    },
    white: {
      alpha: {
        30: primitives.white.alpha[30][systemTheme],
        20: primitives.white.alpha[20][systemTheme],
      },
    },
    black: {
      alpha: {
        30: primitives.black.alpha[30][systemTheme],
        20: primitives.black.alpha[20][systemTheme],
      },
    },
  }
}

export default generatePrimitiveColors
